import { FC, useEffect, useState } from 'react';
import { ScrollArea, SegmentedControl, SegmentedControlProps } from '@mantine/core';
import cn from 'classnames';
import styles from './pills.module.scss';

interface PillsProps extends SegmentedControlProps {
  scrollable?: boolean;
  classNames?: {
    root?: string;
    label?: string;
    control?: string;
    indicator?: string;
    scroll?: {
      root?: string;
      bar?: string;
      thumb?: string;
      viewport?: string;
    };
  }
}

export const Pills: FC<PillsProps> = ({ data, disabled, value, scrollable, classNames, ...props }) => {
  const [safeValue, setSafeValue] = useState(value);
  const typeOfData = typeof data?.[0];
  const isDataSafe = data.every((item) => typeof item === typeOfData);

  useEffect(() => {
    const doesValueForPillsExist = data?.find((item) => {
      if(typeof item !== 'string') return item?.value === value;

      return item === value;
    });

    if(doesValueForPillsExist) {
      setSafeValue(value);
    } else {
      if (typeof data?.[0] === 'string') {
        setSafeValue(data[0]);
      } else {
        setSafeValue(data?.[0]?.value);
      }
    }
  }, [data, value]);

  if(!data || !data.length || !isDataSafe) return null;

  const pill = (
    <SegmentedControl
      data={data}
      disabled={disabled}
      classNames={{
        root: cn(styles.root, disabled && styles.disabled, classNames?.root),
        label: cn(styles.label, classNames?.label),
        control: cn(styles.control, classNames?.control),
        indicator: cn(styles.indicator, classNames?.indicator),
      }}
      value={safeValue}
      {...props}
    />    
  );

  return scrollable ? (
    <ScrollArea
      w='100%'
      type='always'
      offsetScrollbars
      scrollbarSize='8px'
      classNames={{
        root: cn(styles.scroll__root, classNames?.scroll?.root),
        scrollbar: cn(styles.scroll__bar, classNames?.scroll?.bar),
        thumb: cn(styles.scroll__thumb, classNames?.scroll?.thumb),
        viewport: cn(styles.scroll__viewport, classNames?.scroll?.viewport),
      }}
    >
      {pill}
    </ScrollArea>
  ) : pill;
};
